<ng-container *transloco="let t">
  <app-page-template>
    <div class="container">
      <div class="pt-120-60 pb-300-100">
        <app-grey-card-with-title [title]="t('app.common.forgot.password')" [removeContentPaddingTop]="true">
          <div class="text-center pb-20 pt-20">
            <span>{{ t('recover.lost.password.enter.email') }}</span>
          </div>
          <div class="pt-16">
            <form #requestAccountRecovery="ngForm" [formGroup]="inputForm">
              <app-input formControlName="email" label="app.common.email"/>
              <div class="row pt-20-10 mt-30">
                <div class="col-12 col-md-6 mb-3 mb-lg-0">
                  <app-button-alt [buttonColor]="'transparent'" [textColor]="'var(--grey-neutral-800)'"
                                  [text]="t('recover.lost.password.back.to.log.in')" [borderColor]="'var(--teal-500)'"
                                  (onClickCallback)="toLogin()" [isFullWidth]="true"></app-button-alt>
                </div>
                <div class="col-12 col-md-6">
                  <app-button-alt [text]="t('recover.lost.password.account.recovery')"
                                  (onClickCallback)="onSubmit()" [isFullWidth]="true"></app-button-alt>
                </div>
              </div>
            </form>
          </div>
        </app-grey-card-with-title>
      </div>
    </div>
  </app-page-template>
</ng-container>
